import React from 'react'

const Gallery = () => {
  return (
    <div>
      
    </div>
  )
}

export default Gallery
